import React, { useState } from 'react'
import SessionFeedbackFormModal from './SessionFeedbackFormModal'
import encode from '../utils/encode'
import '../assets/css/feedbackForm.css'
import SubmitMessage from './FeedbackFormSubmitMessage'
import submitMessages from '../assets/data/feedbackFormsubmitMessages.json'

const handleSubmit = (
  e,
  sessionId,
  name,
  email,
  contentRating,
  speakerRating,
  sessionComment,
  updateFormState
) => {
  fetch('/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: encode({
      'form-name': 'Feedback',
      sessionId,
      name,
      email,
      contentRating,
      speakerRating,
      sessionComment,
    }),
  })
    .then(() =>
      updateFormState(
        <SubmitMessage
          heading={submitMessages.success.heading}
          body={submitMessages.success.body}
        />
      )
    )
    .catch(() =>
      updateFormState(
        <SubmitMessage
          heading={submitMessages.error.heading}
          body={submitMessages.error.body}
        />
      )
    )

  e.preventDefault()
}

const SessionFeedbackForm = (props) => {
  const [name, updateName] = useState('')
  const [email, updateEmail] = useState('')
  const [contentRating, updateContentRating] = useState('')
  const [speakerRating, updateSpeakerRating] = useState('')
  const [sessionComment, updateSessionComment] = useState('')
  const [formState, updateFormState] = useState('')
  const sessionId = props.sessionAltId

  return (
    <SessionFeedbackFormModal
      formState={formState}
      updateFormState={updateFormState}
    >
      <div id="main" className="FeedbackForm">
        <form
          method="post"
          data-netlify="true"
          name="Feedback"
          netlify-honeypot="bot-field"
          onSubmit={(e) =>
            handleSubmit(
              e,
              sessionId,
              name,
              email,
              contentRating,
              speakerRating,
              sessionComment,
              updateFormState
            )
          }
        >
          <input type="hidden" name="form-name" value="Feedback" />
          <input type="hidden" name="sessionId" value={sessionId} />
          <input type="hidden" name="bot-field" />
          <div>
            <label htmlFor="session">
              {props.sessionTitle} by {props.speakerName}
            </label>
          </div>
          <div>
            <label htmlFor="name">Name (Optional)</label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={(e) => updateName(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="email">Email (Optional)</label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={(e) => updateEmail(e.target.value)}
            />
          </div>
          <div className="box">
            <label htmlFor="contentRating">
              How would you rate the content of this session?
            </label>

            <select
              name="contentRating"
              id="contentRating"
              required
              onChange={(e) => updateContentRating(e.target.value)}
            >
              <option selected value="">Select a rating</option>
              <option value="5">Excellent</option>
              <option value="4">Very Good</option>
              <option value="3">Average</option>
              <option value="2">Poor</option>
              <option value="1">Terrible</option>
            </select>
          </div>
          <div className="box">
            <label htmlFor="speakerRating">
              How would you rate the speaker(s) of this session?
            </label>

            <select
              name="speakerRating"
              id="speakerRating"
              required
              onChange={(e) => updateSpeakerRating(e.target.value)}
            >
              <option selected value="">Select a rating</option>
              <option value="5">Excellent</option>
              <option value="4">Very Good</option>
              <option value="3">Average</option>
              <option value="2">Poor</option>
              <option value="1">Terrible</option>
            </select>
          </div>

          <div>
            <label htmlFor="sessionComment">Comments or Suggestions?</label>
            <textarea
              id="sessionComment"
              name="sessionComment"
              rows="4"
              cols="50"
              onChange={(e) => updateSessionComment(e.target.value)}
            >
              </textarea>
          </div>
          <p className="privacy-terms">
            By submitting this form, you agree to Momentum's
            <a href="/terms-of-use"> Terms of Use</a> and
            <a href="/privacy-policy"> Privacy Policy</a>.
          </p>
          <button type="submit">Submit</button>
        </form>
      </div>
    </SessionFeedbackFormModal>
  )
}

export default SessionFeedbackForm
